import { IconImage } from 'bold-ui'
import {
  tipoDomicilioEnumRecord,
  tipoLocalizacaoEnumRecord,
} from 'components/form/field/select/CondicoesMoradiaSelectFields/condicoes-moradia-model'
import { MapMarkerModel } from 'components/map/map-model'
import { TipoDomicilioEnum, TipoImovelEnum, TipoLocalizacaoEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { humanizeDate } from 'util/date/humanize-date'
import { formatNumber } from 'util/number'
import { isTipoImovelResidencial } from 'view/cadastro-imovel/utils-cadastroImovel'

import { MapaTerritorioMarker } from './components/MapaTerritorioMarker'
import { TerritorioPinoComCoordenadas, TerritorioPinoModel } from './model-territorioMapa'

export function possuiCoordenadas(imovel: TerritorioPinoModel): imovel is TerritorioPinoComCoordenadas {
  return imovel.latitude != null && imovel.longitude != null
}

export function toMapMarkerModel(imovel: TerritorioPinoComCoordenadas): MapMarkerModel {
  return {
    id: imovel.id,
    coordinates: [imovel.longitude, imovel.latitude],
    content: <MapaTerritorioMarker imovelId={imovel.id} tipoImovel={imovel.tipoImovel ?? TipoImovelEnum.OUTROS} />,
  }
}

export function toMapMarkers(imoveis: ReadonlyArray<TerritorioPinoModel>): MapMarkerModel[] {
  return imoveis.filter(possuiCoordenadas).map(toMapMarkerModel)
}

export function getImovelModalHeaderTags(
  tipoImovel: TipoImovelEnum | null,
  tipoDomicilio: TipoDomicilioEnum | null,
  tipoLocalizacao: TipoLocalizacaoEnum | null,
  numeroMoradores: number | null,
  dataUltimaVisita: LocalDate | null,
  possuiOutrosProfsVinculados: boolean
): { icon?: IconImage; label: string | null }[] {
  const tags: { icon?: IconImage; label: string | null }[] = []

  if (tipoDomicilio) {
    tags.push({ label: tipoDomicilioEnumRecord[tipoDomicilio] })
  }

  if (tipoLocalizacao) {
    tags.push({ label: tipoLocalizacaoEnumRecord[tipoLocalizacao] })
  }

  if (isUndefinedOrNull(numeroMoradores)) {
    tags.push({ icon: 'userFilled', label: 'Sem registro de morador' })
  }

  if (tipoImovel && isTipoImovelResidencial(tipoImovel) && !isUndefinedOrNull(numeroMoradores)) {
    tags.push({ icon: 'userFilled', label: `${numeroMoradores} ${numeroMoradores === 1 ? 'morador' : 'moradores'}` })
  }

  if (possuiOutrosProfsVinculados) {
    tags.push({ icon: 'medicalCrossFilled', label: 'Outros profissionais de saúde vinculados' })
  }

  tags.push({ label: `Última visita: ${dataUltimaVisita ? humanizeDate(dataUltimaVisita) : 'sem registro'}` })

  return tags
}

export function formatResults(total: number): string {
  return `${formatNumber(total)} ${total === 1 ? 'resultado' : 'resultados'}`
}
